import { Tooltip } from "@moznsystems/mozn-ui";
import type { ComponentProps, FC, ReactElement, ReactNode } from "react";

type TextTooltipProps = {
	content: ReactNode;
	/**
	 * The trigger. mozn-ui clones it with ref and hover/focus handlers, so it
	 * must be a single DOM element that can take focus (a `<button>`, or an
	 * element with `tabIndex={0}`) for keyboard users to reach the tooltip.
	 */
	children: ReactElement;
	placement?: ComponentProps<typeof Tooltip>["placement"];
};

// Same layer as the popups positioned by `usePopupPosition`.
const TOOLTIP_Z_INDEX = 9999;

/**
 * Dark text tooltip shown on hover or keyboard focus of `children`. mozn-ui's
 * `Tooltip` renders into `document.body`, so the popup is not clipped by an
 * `overflow: hidden` ancestor and stays outside a wrapping link.
 */
const TextTooltip: FC<TextTooltipProps> = ({
	content,
	children,
	placement = "top",
}) => (
	<Tooltip
		label={content}
		placement={placement}
		hasArrow={false}
		zIndex={TOOLTIP_Z_INDEX}
		className="!max-w-[340px] !rounded-xl !border-0 !bg-gray-1 !px-4 !py-3 !font-medium !text-white !text-xs"
	>
		{children}
	</Tooltip>
);

export { TextTooltip };
